import type {RefObject} from 'react'
import type {HandleUserSubmit} from '../types/user-submit'
import {AGENT_TASKS_SELECTED_MODEL_KEY} from './constants'

export function submitTask(message: string, handleUserSubmitRef: RefObject<HandleUserSubmit>) {
  try {
    // Try to parse as JSON to see if it contains repo/branch data
    const parsed = JSON.parse(message)
    if (parsed.text !== undefined) {
      // It's the new format with repo/branch data
      const selectedRepo = parsed.selectedRepo
        ? {
            ...parsed.selectedRepo,
            private: parsed.selectedRepo.visibility === 'private',
          }
        : null
      const selectedBranch = parsed.selectedBranch || ''
      const selectedAgent = parsed.selectedAgent

      let modelId = parsed.model?.id // Model ID will be present if passed from task-request reference

      // If no model ID in parsed data, try to get it from localStorage
      if (!modelId) {
        try {
          modelId = localStorage.getItem(AGENT_TASKS_SELECTED_MODEL_KEY) ?? undefined
        } catch {
          // localStorage might not be available (SSR, etc)
        }
      }

      // Append serialized file/snippet reference URLs to the task text if present
      const references = Array.isArray(parsed.references)
        ? (parsed.references as unknown[]).filter((ref): ref is string => typeof ref === 'string')
        : []
      const textWithRefs = references.length > 0 ? `${parsed.text}\n\n${references.join('\n')}` : parsed.text

      if (references.length > 0) {
        handleUserSubmitRef.current(
          textWithRefs,
          selectedRepo,
          selectedBranch,
          selectedAgent || '',
          undefined,
          modelId,
          {
            references,
          },
        )
      } else {
        handleUserSubmitRef.current(textWithRefs, selectedRepo, selectedBranch, selectedAgent || '', undefined, modelId)
      }
    } else {
      // JSON parsed but doesn't have expected structure, treat as plain text

      handleUserSubmitRef.current(message, null, '', {})
    }
  } catch {
    // Not JSON, treat as plain text (old format)

    handleUserSubmitRef.current(message, null, '', {})
  }
}
